import React, { Component } from 'react';
import { LandingTop } from './Home/LandingTop';
import { MainHomeBanner } from './Home/MainHomeBanner';
import { HomeWhyFakeXrmSection} from './Home/HomeWhyFakeXrmSection';

import $ from 'jquery';
import { Community } from './Home/Community';
import { HomeLiterals } from '../literals/home/HomeLiterals';
import { getLiteralsForCulture } from '../literals/Literals';
import { AnimationComponentUtils } from './Utils/ComponentUtils';
import { Footer } from './Footer';
import { AppState } from './AppState';
import { Testimonials } from './Home/Testimonials';
import { ResearchStudy } from './Home/ResearchStudy';
import { CustomerStories } from '../components/CustomerStories/CustomerStories';
interface HomeProps
{
  appState: AppState;
}

export class Home extends Component<HomeProps> {
  static displayName = Home.name;

  render () {
    const literals = getLiteralsForCulture(HomeLiterals, this.props.appState.currentCulture) as any;
    
    return (
      <div style={{height: "100%"}}>
          <LandingTop appState={this.props.appState}></LandingTop>
          <ResearchStudy appState={this.props.appState}></ResearchStudy>
          <HomeWhyFakeXrmSection appState={this.props.appState}></HomeWhyFakeXrmSection>
          <Testimonials appState={this.props.appState}></Testimonials>
          <MainHomeBanner appState={this.props.appState}></MainHomeBanner>
          <CustomerStories appState={this.props.appState}></CustomerStories>
          <Community appState={this.props.appState}></Community>
          <Footer appState={this.props.appState}></Footer>
      </div>
    );
  }
  
  componentDidMount()
  {
    AnimationComponentUtils.registerEvents(window);
    AnimationComponentUtils.checkIfInView($(window));
  }
}
